import { formatNormalizedDateForDisplay, normalizeBackendDate } from './dateFormatters';

export const formatDisplayDate = (date) => formatNormalizedDateForDisplay(date);

export const formatDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getCurrentCampaignRange = (baseDate = new Date()) => {
  const currentYear = baseDate.getFullYear();
  const currentMonth = baseDate.getMonth();
  const startYear = currentMonth >= 9 ? currentYear : currentYear - 1;

  return getCampaignRangeByStartYear(startYear);
};

export const getCampaignRangeByStartYear = (startYear) => {
  const numericStartYear = Number(startYear);

  return {
    startYear: numericStartYear,
    start: new Date(numericStartYear, 9, 1),
    end: new Date(numericStartYear + 1, 8, 30),
    startValue: `${numericStartYear}-10-01`,
    endValue: `${numericStartYear + 1}-09-30`,
  };
};

export const getCampaignStartYearFromDate = (dateValue) => {
  const [year, month] = normalizeBackendDate(dateValue).split('-').map((value) => Number(value));

  if (!year || !month) {
    return null;
  }

  return month >= 10 ? year : year - 1;
};

export const getCampaignLabel = (startYear) => `${startYear}/${Number(startYear) + 1}`;

export const getCampaignOptionsFromEntries = (rows, baseDate = new Date()) => {
  const currentCampaign = getCurrentCampaignRange(baseDate).startYear;
  const campaignYears = new Set([currentCampaign]);

  rows.forEach((row) => {
    const campaignStartYear = getCampaignStartYearFromDate(row.fecha);

    if (campaignStartYear) {
      campaignYears.add(campaignStartYear);
    }
  });

  return Array.from(campaignYears)
    .sort((a, b) => b - a)
    .map((startYear) => ({
      startYear,
      label: getCampaignLabel(startYear),
      ...getCampaignRangeByStartYear(startYear),
    }));
};

export const addDays = (date, days) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);

  return nextDate;
};

export const getDefaultEntryDateFilters = (baseDate = new Date()) => {
  const { start, end } = getCurrentCampaignRange(baseDate);

  return {
    desde: formatDateInputValue(start),
    hasta: formatDateInputValue(end),
  };
};

export const sortEntriesByDateDesc = (rows) =>
  [...rows].sort((a, b) => {
    const dateCompare = normalizeBackendDate(b.fecha).localeCompare(normalizeBackendDate(a.fecha));

    if (dateCompare !== 0) {
      return dateCompare;
    }

    return Number(b.codigo) - Number(a.codigo);
  });

export const getLatestEntries = (rows, limit = 6) =>
  sortEntriesByDateDesc(rows).slice(0, limit);

export const groupEntriesByDate = (rows, warehouses = [], warehouseColors = {}) =>
  sortEntriesByDateDesc(rows).reduce((acc, row) => {
    const normalizedDate = normalizeBackendDate(row.fecha);
    const current = acc.get(normalizedDate) || {
      fecha: normalizedDate,
      kilosVolcados: 0,
      kilosClasificados: 0,
      registros: 0,
      segments: warehouses.map((warehouse) => ({
        label: warehouse.nombre,
        idAlmacen: warehouse.id,
        value: 0,
        color: warehouseColors[warehouse.id],
      })),
    };

    current.kilosVolcados += row.kilosVolcados;
    current.kilosClasificados += row.kilosClasificados;
    current.registros += 1;
    current.segments = current.segments.map((segment) => (
      segment.idAlmacen === row.idAlmacen
        ? { ...segment, value: segment.value + row.kilosVolcados }
        : segment
    ));

    acc.set(normalizedDate, current);
    return acc;
  }, new Map());

export const getDailyEvolution = (rows, warehouses = [], warehouseColors = {}) =>
  Array.from(groupEntriesByDate(rows, warehouses, warehouseColors).values()).map((row) => ({
    ...row,
    rendimiento: row.kilosVolcados > 0
      ? (row.kilosClasificados * 100) / row.kilosVolcados
      : 0,
  }));
